import { useState } from "react";

import { useTranslation } from "react-i18next";

import { Button, Divider, Icon, Message } from "semantic-ui-react";

import { useAppSelector } from "store";

import { EnableMfa, SuggestedMFAApps } from "../EnableMfa";

const EnforceMFA = () => {
  const { t } = useTranslation();
  const [mfaEnabledModalOpen, setMfaEnabledModalOpen] = useState(false);

  const user = useAppSelector((state) => state.user);

  return (
    <>
      <h3>
        <Icon name="lock" style={{ paddingRight: "10px" }} />
        {t("entry.mfa.title")} {t("generic.required")}
      </h3>
      <p>
        {t("entry.mfa.requiredByOrg", {
          orgName: user.ownerOrganisation?.name,
        })}
      </p>
      <p>{t("entry.mfa.explainer")}</p>
      <Message info>
        <SuggestedMFAApps />
      </Message>
      <Divider />

      <div style={{ textAlign: "right" }}>
        <Button
          primary
          style={{ maxWidth: "fit-content" }}
          icon={"lock"}
          content={t("entry.mfa.enableAction")}
          onClick={() => setMfaEnabledModalOpen(true)}
        />
      </div>

      <EnableMfa
        open={mfaEnabledModalOpen}
        onClose={() => setMfaEnabledModalOpen(false)}
        onEnableMfa={() => {}}
      />
    </>
  );
};

export default EnforceMFA;
